import clsx from 'clsx'

type CitationBadgeProps = {
  label: string
  /** Renders the badge as its own external link. Omit when the badge sits inside another anchor. */
  href?: string
  title?: string
  /** 'brand' = tenant-tinted pill (clickable sources), 'neutral' = gray pill (non-clickable references). */
  variant?: 'brand' | 'neutral'
  size?: 'sm' | 'md'
  className?: string
}

const SIZE_CLASSES = {
  sm: 'tw-text-xs tw-min-w-[16px] tw-h-4',
  md: 'tw-text-xs tw-min-w-[18px] tw-h-[18px]',
}

export const CitationBadge = ({
  label,
  href,
  title,
  variant = 'brand',
  size = 'md',
  className,
}: CitationBadgeProps) => {
  const classes = clsx(
    'tw-inline-flex tw-items-center tw-justify-center tw-font-bold tw-rounded-full tw-flex-shrink-0',
    SIZE_CLASSES[size],
    variant === 'brand' && 'citation-pill tw-transition-colors',
    className,
  )
  const neutralStyle =
    variant === 'neutral' ? { backgroundColor: 'var(--input-bg)', color: 'var(--text-muted)' } : undefined

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        title={title}
        className={clsx(classes, 'tw-no-underline tw-cursor-pointer')}
        style={neutralStyle}
      >
        {label}
      </a>
    )
  }

  return (
    <span title={title} className={classes} style={neutralStyle}>
      {label}
    </span>
  )
}
